var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentTranslation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2851 0.378413C53.1152 0.288413 51.9351 0.248413 50.7451 0.248413C23.1351 0.248413 0.745148 22.6384 0.745148 50.2484C0.745148 77.8584 23.1351 100.248 50.7451 100.248C72.3051 100.248 90.6751 86.5984 97.6951 67.4784C99.6651 62.1084 100.745 56.2984 100.745 50.2484C100.745 23.8284 80.2451 2.18841 54.2851 0.378413ZM90.8151 68.4284C83.8751 83.6484 68.5251 94.2484 50.7451 94.2484C26.4851 94.2484 6.74515 74.5084 6.74515 50.2484C6.74515 42.7784 8.61515 35.7484 11.9151 29.5784C19.3251 15.7084 33.9551 6.24841 50.7451 6.24841C75.0051 6.24841 94.7451 25.9884 94.7451 50.2484C94.7451 56.7284 93.3351 62.8884 90.8151 68.4284Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3251 59.3384C35.3251 59.3384 35.3251 54.6784 40.0451 50.5684C37.4751 48.0084 34.9751 44.0984 32.6051 37.3484C32.8651 37.2284 33.0451 36.9684 33.0451 36.6684C33.0451 36.2584 32.7151 35.9184 32.2951 35.9184C32.1551 35.9184 32.0251 35.9584 31.9151 36.0184C31.9151 36.0184 31.8851 36.0384 31.8751 36.0384V49.5984C33.0151 49.8784 33.8651 50.9184 33.8651 52.1484C33.8651 53.0684 33.3951 53.8684 32.6851 54.3384C32.4451 54.4984 32.1651 54.6184 31.8751 54.6884C31.6751 54.7384 31.4551 54.7684 31.2351 54.7684C31.0151 54.7684 30.8051 54.7384 30.5951 54.6884C30.3051 54.6184 30.0351 54.4984 29.7851 54.3384C29.0751 53.8684 28.6051 53.0584 28.6051 52.1484C28.6051 50.9184 29.4551 49.8884 30.5951 49.5984V36.0384C30.5951 36.0384 30.5651 36.0184 30.5551 36.0184C30.4451 35.9484 30.3151 35.9184 30.1751 35.9184C29.7651 35.9184 29.4251 36.2484 29.4251 36.6684C29.4251 36.9684 29.6051 37.2284 29.8651 37.3484C27.4951 44.0984 24.9951 48.0084 22.4251 50.5684C27.1351 54.6784 27.1451 59.3184 27.1451 59.3384H35.3251Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4151 60.6084H27.0851C26.7538 60.6084 26.4851 60.877 26.4851 61.2084V62.9584C26.4851 63.2898 26.7538 63.5584 27.0851 63.5584H35.4151C35.7465 63.5584 36.0151 63.2898 36.0151 62.9584V61.2084C36.0151 60.877 35.7465 60.6084 35.4151 60.6084Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8951 83.3684C28.9751 84.6084 30.0051 85.5784 31.2451 85.5784C32.4851 85.5784 33.5251 84.6084 33.5951 83.3684L34.7351 64.8184H27.7551L28.8951 83.3684Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4151 48.1184C48.4151 51.3484 49.9651 54.3084 52.5651 56.6184L50.8651 68.3584L59.4951 60.4584C61.7551 61.1784 64.2452 61.5784 66.8652 61.5784C77.0552 61.5784 85.3151 55.5484 85.3151 48.1184C85.3151 40.6884 77.0552 34.6584 66.8652 34.6584C56.6752 34.6584 48.4151 40.6884 48.4151 48.1184ZM57.5851 51.1984C55.8751 51.1984 54.4951 49.8184 54.4951 48.1084C54.4951 46.3984 55.8751 45.0184 57.5851 45.0184C59.2951 45.0184 60.6751 46.3984 60.6751 48.1084C60.6751 49.8184 59.2951 51.1984 57.5851 51.1984ZM76.1251 45.0184C77.8351 45.0184 79.2151 46.3984 79.2151 48.1084C79.2151 49.8184 77.8351 51.1984 76.1251 51.1984C74.4151 51.1984 73.0351 49.8184 73.0351 48.1084C73.0351 46.3984 74.4151 45.0184 76.1251 45.0184ZM69.9451 48.1084C69.9451 49.8184 68.5651 51.1984 66.8551 51.1984C65.1451 51.1984 63.7651 49.8184 63.7651 48.1084C63.7651 46.3984 65.1451 45.0184 66.8551 45.0184C68.5651 45.0184 69.9451 46.3984 69.9451 48.1084Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6151 25.3184V15.8684L31.3151 27.1684H40.7651C41.7851 27.1684 42.6151 26.3384 42.6151 25.3184Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8651 52.7584C30.9351 52.7984 31.0051 52.8384 31.0851 52.8584C31.1351 52.8684 31.1951 52.8784 31.2551 52.8784C31.3151 52.8784 31.3751 52.8784 31.4351 52.8584C31.5151 52.8384 31.5851 52.8084 31.6551 52.7584C31.8551 52.6284 31.9751 52.3984 31.9751 52.1584C31.9751 51.8284 31.7551 51.5384 31.4351 51.4584L31.2551 51.4184L31.0751 51.4584C30.7551 51.5384 30.5351 51.8284 30.5351 52.1584C30.5351 52.3984 30.6551 52.6284 30.8651 52.7584Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9851 62.5684V62.5884L48.1951 73.3684L50.5251 57.3084C47.9251 54.6684 46.4951 51.4384 46.4951 48.0984C46.4951 45.9384 47.0651 43.8584 48.2051 41.8984C49.2651 40.0684 50.7751 38.4284 52.6851 37.0384C56.4951 34.2584 61.5251 32.7284 66.8551 32.7284C68.9851 32.7284 71.0651 32.9684 73.0351 33.4484V14.9084H44.5151V25.3084C44.5151 27.3784 42.8351 29.0584 40.7651 29.0584H30.3651V33.9984C30.6751 34.0184 30.9751 34.0884 31.2551 34.2084C31.5851 34.0684 31.9451 33.9884 32.3051 33.9884C33.7651 33.9884 34.9651 35.1784 34.9651 36.6484C34.9651 36.9984 34.8951 37.3484 34.7651 37.6584C36.6851 42.8884 38.8651 46.6684 41.4051 49.1984L42.8551 50.6384L41.3151 51.9784C39.6551 53.4284 38.4751 55.0984 37.7851 56.9484C37.2851 58.2984 37.2451 59.2584 37.2451 59.3284V59.4684C37.6751 59.9184 37.9351 60.5284 37.9351 61.1884V62.9284C37.9351 63.8684 37.4151 64.6884 36.6451 65.1184L35.9351 76.6984H73.0452V62.7384C71.0751 63.2084 68.9951 63.4584 66.8652 63.4584C64.4952 63.4584 62.1852 63.1584 59.9851 62.5684ZM49.6751 18.7284H69.2151V20.6384H49.6751V18.7284ZM49.6751 22.5484H69.2151V24.4584H49.6751V22.5484ZM49.6751 26.3584H66.6751V28.2684H49.6751V26.3584Z",
    fill: "#9933CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1691",
    x: 0.0000118613,
    y: 0.0000344813,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1691"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1691",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1691"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1691",
    result: "effect3_innerShadow_4857_1691"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentTranslation);
export default __webpack_public_path__ + "static/media/ContentTranslation.0e152f7bb273055b018c594f07dcfc58.svg";
export { ForwardRef as ReactComponent };